<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :url="url"
                      :operate="[]"
                      :form-fields="formFields"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "PromotionSetting",
        components: {CommonTable},data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission: {
                    add: 'promotionSetting:add',
                    update: 'promotionSetting:update',
                    delete: 'promotionSetting:delete',
                    deleteBatch: 'promotionSetting:deleteBatch'
                },
                url: {
                    get: '/promotionSetting/listByCondition',
                    add: '/promotionSetting/add',
                    update: '/promotionSetting/update',
                    delete: '/promotionSetting/delete',
                    delete_batch: '/promotionSetting/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'minAmount',
                    label: '最小充值金额',
                    show: true,
                    width: '',
                }, {
                    field: 'maxAmount',
                    label: '最大充值金额',
                    show: true,
                    width: '',
                }, {
                    field: 'level1Ratio',
                    label: '一级返比',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                    field: 'level2Ratio',
                    label: '二级返比',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                    field: 'level3Ratio',
                    label: '三级返比',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加推广返佣设置',
                    updateTitle: '修改推广返佣设置',
                    labelWidth: '90px',
                    model: [{
                        field: 'agentId',
                        label: '代理：',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'minAmount',
                        label: '最小金额',
                        type: 'input',
                        placeholder: '最小充值金额(USDT)',
                        rules:[{
                            message: '请输入最小充值金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'maxAmount',
                        label: '最大金额',
                        type: 'input',
                        placeholder: '最大充值金额(USDT)',
                        rules:[{
                            message: '请输入最大充值金额', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level1Ratio',
                        label: '一级返比',
                        type: 'money',
                        placeholder: '一级返佣比例(%)',
                        rules:[{
                            message: '请输入一级返佣比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level2Ratio',
                        label: '二级返比',
                        type: 'money',
                        placeholder: '二级返佣比例(%)',
                        rules:[{
                            message: '请输入二级返佣比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'level3Ratio',
                        label: '三级返比',
                        type: 'money',
                        placeholder: '三级返佣比例(%)',
                        rules:[{
                            message: '请输入三级返佣比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
